import React from 'preact/compat';
import { useFormikContext } from 'formik';
import { useEmailFormContext } from './context';

export default function Submit() {
    const { isSubmitting } = useFormikContext();
    const {
        privacyPolicy,
        classNames: {
            button: {
                submit: buttonClassName,
            },
        },
    } = useEmailFormContext();

    return (
        <div className='form__grid-item  form__grid-item--wide'>
            <p className='form__footer'>By submitting this form, you agree to the Fair Processing of your personal data we will only contact you in respect of your enquiry. Your details will be deleted in accordance with our <a href={privacyPolicy} target='_blank' rel='noopener noreferrer'>Fair Processing Notice</a>.</p>
            <p className='form__footer'>Verbal abuse, the use of inappropriate language and or threatening behaviour towards our team and community of brands, will not be tolerated and we reserve the right to refuse to serve you.</p>
            <div className='form__footer'>
                <button type='submit' disabled={isSubmitting} className={buttonClassName}>
                    Send email
                </button>
            </div>
        </div>
    );
}
